// extracted by mini-css-extract-plugin
export default {"wrapper__input":"UiInput_wrapper__input__62Ww9","input":"UiInput_input__IgVx0","clear":"UiInput_clear__OLezJ","clear__disabled":"UiInput_clear__disabled__5Akg0"};